import { render } from "./MiniLoader.vue?vue&type=template&id=220d5901&scoped=true"
import script from "./MiniLoader.vue?vue&type=script&lang=js"
export * from "./MiniLoader.vue?vue&type=script&lang=js"

import "./MiniLoader.vue?vue&type=style&index=0&id=220d5901&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\galita-api\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220d5901"]])

export default __exports__